import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { useAuth } from '../contexts/AuthContext';
import { firstPagePath, ALL_NAV_ITEMS } from '../ui/AppShell/navigation';

/**
 * The app's home ("/"): the first page in the menu the user's role opens - the Overview for a role that has it, else
 * e.g. Contracts or Traffic Fines (owner, 4 Oct 2026: "الناس اللى انا مش مديها صلاحية الداشبورد ازاى هيستخدموا باقى
 * الموقع" - sign-in, the logo and every Back went to /dashboard and showed Access Denied). Inside ProtectedRoute, so
 * the user is signed in.
 */
export default function HomeRedirect() {
    const { hasPermission, viewingAs } = usePermissions();
    const { currentUser } = useAuth();
    return <Navigate to={homePathOf(currentUser?.homePage, hasPermission, viewingAs)} replace />;
}

/**
 * The page a user opens on: the start page an admin chose for them in User Management (owner, 4 Oct 2026: "يوزر اول
 * صفحه تفتحله الداشبورد ويوزر تانى صفحة المطار ويوزر تانى صفحة الشهري") when their role still opens it, else the
 * role's first page. While an admin looks through a role, the role's first page.
 */
export const homePathOf = (homePage, can, viewingAs = null) => {
    const chosen = !viewingAs && homePage ? ALL_NAV_ITEMS.find((i) => i.path === homePage) : null;
    return chosen && (!chosen.permission || can(chosen.permission)) ? chosen.path : firstPagePath(can);
};
